import {makeAutoObservable, runInAction} from "mobx";
import CreateRmaService, {IStoreLocationsMap} from "../../../services/api/create-rma-service";
import {rootContainer, TYPE} from "../../../services/container/root";
import CreateRmaSettingsStore from "./create-rma-settings-store";
import PlatformProductStore from "./platform-product-store";
import PlatformVariantStore from "./platform-variant-store";

class PlatformProductSearchStore {
    private _searchInputText: string = '';
    private _isSearching: boolean = false;
    private _productList: PlatformProductStore[] = [];
    private _selectedProduct?: PlatformProductStore;
    private _selectedlocationId?: string;
    
    constructor(private _createRmaSettingsStore: CreateRmaSettingsStore) {
        makeAutoObservable(this, {}, {autoBind: true});
    }
    
    public get isSearching() : boolean { return this._isSearching; }
    public get searchInputText() : string { return this._searchInputText; }
    public get productList(): PlatformProductStore[] { return this._productList; }
    public get selectedProduct(): PlatformProductStore | undefined { return this._selectedProduct; }
    public get selectedProductVariant(): PlatformVariantStore | undefined { return this._selectedProduct?.selectedVariant; }
    public get locations(): IStoreLocationsMap { return this._createRmaSettingsStore.locations; }
    public get selectedlocationId(): string | undefined { return this._selectedlocationId ?? this._createRmaSettingsStore.currentLocation; }
    public get isLoadingLocations(): boolean { return this._createRmaSettingsStore.isLoading; }
    
    private get _service(): CreateRmaService { return rootContainer.get<CreateRmaService>(TYPE.CreateRmaService); }
    
    public async search()  {
        this._isSearching = true;
        try {
            const results = await this._service.searchProductExchange(this._searchInputText, this.selectedlocationId);
            runInAction(() => {
                this._isSearching = false;
                this._productList = results.products.map((product) => new PlatformProductStore(product, this));
            });
        }
        catch (e){
            runInAction(() => {
                this._isSearching = false;
            });
        }
    }
    
    
    public setSearchInputText(input : string) {
        this._searchInputText = input;
    }
    
    public selectProductVariant(product: PlatformProductStore, variant: PlatformVariantStore) {
        this._selectedProduct = product;
        this._selectedProduct.selectVariant(variant);
    }
    
    public selectProduct(product: PlatformProductStore) {
        this._selectedProduct = product;
    }
    
    public setLocationId(value: string) {
        this._selectedlocationId = value;
    }
}

export { PlatformProductSearchStore as default };
